import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { getTotpFormConfig } from './form-config/totp-form-config.js';

var KeycloakTotp = /** @class */ (function (_super) {
    __extends(KeycloakTotp, _super);
    function KeycloakTotp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formConfig = null;
        return _this;
    }
    KeycloakTotp.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, getTotpFormConfig((_a = this.kcContext.message) === null || _a === void 0 ? void 0 : _a.summary)];
                    case 1:
                        _b.formConfig = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(KeycloakTotp.prototype, "totpAction", {
        get: function () {
            return this.kcContext.url.loginAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakTotp.prototype, "supportedApplications", {
        get: function () {
            return this.kcContext.totp.supportedApplications;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakTotp.prototype, "totpSecretQrCode", {
        get: function () {
            return this.kcContext.totp.totpSecretQrCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakTotp.prototype, "totpManualURL", {
        get: function () {
            return window.location.origin + this.kcContext.totp.manualUrl;
        },
        enumerable: false,
        configurable: true
    });
    KeycloakTotp.prototype.submit = function (value) {
        var form = this.$refs['totp-form'];
        this.getInput(form, 'totp').value = value.otp;
        this.getInput(form, 'userLabel').value = value.userLabel;
        form.submit();
    };
    KeycloakTotp.prototype.getInput = function (form, name) {
        return form.elements.namedItem(name);
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakTotp.prototype, "kcContext", void 0);
    KeycloakTotp = __decorate([
        Component({
            name: 'corex-keycloak-totp',
        })
    ], KeycloakTotp);
    return KeycloakTotp;
}(Mixins(MagicConfigMixin)));

export default KeycloakTotp;
